<!-- 修改电表倍率弹窗 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">修改倍率</template>
		<div style="padding-top: 15px;">
			<div class="formContainer">
				<label><span class="required">*</span>登录密码</label>
				<input type="password" v-model.trim="verifyPassword" autocomplete="new-password" placeholder="请输入登录密码" />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>电表倍率</label>
				<input type="number" v-model="magnification" min="1" placeholder="请输入电表倍率" @keydown="keydownInt($event)" />
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: {
			
		},
		data() {
			return {
				callback: undefined,
				verifyPassword: '',
				magnification: 1
			}
		},
		computed: {
			
		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if(this.verifyPassword == '' || this.verifyPassword == undefined){
					this.$dialogMethod.showMessage('登录密码为必填项')
					return
				}else if(parseInt(this.magnification) < 1){
					this.$dialogMethod.showMessage('电表倍率不能少于1')
					return
				}
				if(this.callback != undefined){
					this.callback({magnification:parseInt(this.magnification), password:hex_md5(this.verifyPassword)})
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.verifyPassword = ''
				this.$refs.body.hide()
			},
			open(magnification, callBack) {
				this.magnification = magnification
				this.callback = callBack
				this.$refs.body.open()
			},
			keydownInt(ev) {
				if(ev.keyCode == 109 || ev.keyCode == 229 || ev.keyCode == 110 || ev.keyCode == 190){
					ev.preventDefault()
				}
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		margin-bottom: 12px;
	}
	
	.formContainer>label{
		min-width: 72px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}
	
	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}
	
	.required{
		color: red;
	}
</style>